import React from 'react'
import injectStyles from 'react-jss'
import classnames from 'classnames'
import styles from './styles'
import VectorIcon from '../../../../Assets/Images/icons/vector'
import UndoArrow from '../../../../Assets/Images/icons/undoArrow'

const DrawMapControls = ({
  isDrawing,
  toggleDrawing,
  undoHandler,
  deleteSelected,
  removeAll,
  mapControls = [],
  shouldShowUndo,
  saving,
  classes,
  clearAllLabel,
}) => {
  if (mapControls.length === 0) return null

  return (
    <section className={classes.wrapper}>
      <span className={classes.title}>Actions</span>
      {mapControls.includes('DRAW') && (
        <div
          className={classnames(classes.button, {
            [classes.active]: isDrawing,
          })}
          onClick={() => {
            toggleDrawing()
          }}
        >
          <VectorIcon className={classes.buttonIcon} />
        </div>
      )}
      {shouldShowUndo && (
        <div
          className={classnames(classes.button, {
            [classes.inactive]: saving,
          })}
          onClick={undoHandler}
        >
          <UndoArrow className={classes.buttonIcon} />
        </div>
      )}
      {mapControls.includes('CLEAR_ALL') && (
        <div className={classes.button} onClick={removeAll}>
          {clearAllLabel ? clearAllLabel : 'Clear All'}
        </div>
      )}
    </section>
  )
}

export default injectStyles(styles)(DrawMapControls)



// WEBPACK FOOTER //
// ./src/Components/DrawMap/components/DrawMapControls/DrawMapControls.js